import React, { memo, useEffect, useState, FC, useRef } from "../../../lib/teact/teact";
import Button from "../../ui/Button";
import './snackbar.scss'

type OwerProps = {
    isOpen: boolean;
    duration?: number;
    closeable?: boolean;
    message: string;
    triggerTime: ReturnType<typeof Date>;
    onClose: () => void;
}

const Snackbar: FC<OwerProps> = ({
    isOpen,
    message,
    duration,
    closeable,
    triggerTime,
    onClose
}) => {
    const [open, setOpen] = useState(isOpen);

    // Hàm mở Snackbar
    const handleOpenSnackbar = () => {
        setOpen(true);
    };

    // Hàm đóng Snackbar
    const handleCloseSnackbar = () => {
        setOpen(false);
    };

    // Snackbar mở trong 5 giây và tự đóng
    const autoCloseDuration = duration ? duration : 4000;

    // Sử dụng useEffect để tự động đóng Snackbar sau khi mở
    useEffect(() => {
        setOpen(isOpen)
        if (isOpen) {
            const timer = setTimeout(() => {
                //divRef.current.classList.remove("show")

                onClose()
            }, autoCloseDuration);

            // Clear timer khi component unmount (ngừng render)
            return () => clearTimeout(timer);
        }
    }, [isOpen, triggerTime, open]);
    const divRef = useRef<HTMLDivElement>(null)
    const className = isOpen ? "snackbar show" : "snackbar"
    // console.log('Snackbar auto close after ', autoCloseDuration)
    // console.log('Snackbar text ', message)
    //console.log('className=' + className)
    return (
        <div>
            {/* <button onClick={handleOpenSnackbar}>Mở Snackbar</button> */}
            {(isOpen && open &&
                <div
                    id="snackbar"
                    ref={divRef}
                    className={className}
                >
                    <div>

                        {message}
                    </div>
                    <Button round
                        size="smaller"
                        onClick={(e) => onClose()} >
                        <i
                            className='icon icon-arrow-left'
                            aria-hidden
                        />
                    </Button>
                </div>
            )}
        </div>
    );
}

export default Snackbar;
